import React from 'react';
import { testimonials } from '../data/matikka';
export function Testimonials() {
  // Hidden until authentic MATIKKA VALMIS reviews are added in data/matikka.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-286" data-mp="3fym6mihn2y3a">
      <div className="mx-auto max-w-6xl" data-id="element-287" data-mp="3azj8zj3znu5c">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-288" data-mp="3ayqd5d6kip1z">
          Mitä <em className="text-red-700" data-id="element-289" data-mp="31zw9x3yqf0fg">opettajat</em> sanovat
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-290" data-mp="321z9ofpos7xd">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-291" data-mp="2s1q9kqskq2cp">
              <div className="text-sm text-amber-500" aria-label="5 / 5 tähteä" data-id="element-292" data-mp="2s3jf22rgagj4">
                <span aria-hidden="true" data-id="element-293" data-mp="v8555k5bgowg">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-294" data-mp="qa3pl973n7pq">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-295" data-mp="h814jfcje0g9">
                <span className="font-semibold text-slate-900" data-id="element-296" data-mp="m62oe2hse3ss">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-297" data-mp="78aaferw1ngp"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}